import React from "react";
import ProfileSetting from "../components/setting/ProfileSetting";
import DisplaySetting from "../components/setting/DisplaySetting";
import { useAuth } from "../contexts/AuthContext";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Setting = () => {
    const navigate = useNavigate();
    const { expire, setExpire } = useAuth();

    useEffect(() => {
        if (expire) {
            setExpire(false);
            navigate("/login");
        }
    });

    return (
        <div className="bg-white dark:bg-gray-800 p-6">
            <div className="flex flex-col items-center justify-center mt-5">
                <ProfileSetting
                />
            </div>
            <div className="flex flex-col items-center justify-center mt-5">
                <DisplaySetting
                />
            </div>
        </div>
    );
};

export default  Setting;